<template>
  <div class="border rounded overflow-hidden">
    <table class="w-full divide-y">
      <ProductFeatureManager
        v-for="featureOption in featureOptions"
        :key="featureOption.handle"
        :feature="featureOption"
        :feature-options-value="internalFeatureOptionsValue"
        :feature-permission-options-value="internalFeaturePermissionOptionsValue"
        @update:feature-options-value="handleUpdateFeatureOptionsValue"
        @update:feature-permission-options-value="handleUpdateFeaturePermissionOptionsValue"
      />
      <tfoot v-if="internalFeatureOptionsValue.length">
        <tr>
          <td class="px-4 py-3 font-semibold" colspan="5">Total price</td>
          <td class="px-4 py-3 font-semibold text-right">{{ totalPriceFormatted }}</td>
          <td class="px-4 py-3"></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import Numbro from '@/utils/numbro';
import ProductFeatureManager from './ProductFeatureManager.vue';

export default {
  components: { ProductFeatureManager },
  props: {
    featureOptionsValue: {
      type: Array,
      default: () => [],
    },
    featurePermissionOptionsValue: {
      type: Array,
      default: () => [],
    },
    featureOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      internalFeatureOptionsValue: [],
      internalFeaturePermissionOptionsValue: [],
    };
  },
  computed: {
    totalPrice() {
      return this.internalFeatureOptionsValue.reduce((acc, cur) => {
        return acc + (cur.value * cur.unit_amount + cur.flat_amount);
      }, 0);
    },
    totalPriceFormatted() {
      return `${Numbro(this.totalPrice / 100).format({
        thousandSeparated: true,
        mantissa: 2,
      })}\u20AC`;
    },
  },
  created() {
    this.internalFeatureOptionsValue = JSON.parse(JSON.stringify(this.featureOptionsValue));
    this.internalFeaturePermissionOptionsValue = JSON.parse(
      JSON.stringify(this.featurePermissionOptionsValue)
    );
  },
  methods: {
    handleUpdateFeatureOptionsValue(value) {
      this.internalFeatureOptionsValue = value;
      this.$emit('update:feature-options-value', JSON.parse(JSON.stringify(value)));
    },
    handleUpdateFeaturePermissionOptionsValue(value) {
      this.internalFeaturePermissionOptionsValue = value;
      this.$emit('update:feature-permission-options-value', JSON.parse(JSON.stringify(value)));
    },
  },
};
</script>
